import { withCurrentParams } from 'actions/utils';
import { BROADCAST_CREATE_SANDBOX_MEETING } from 'actions/Types';
import { CREATE_READINESS_CHECK } from 'store/eventConstants';

export default () => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_CREATE_SANDBOX_MEETING,
        request: async apiClient => {
          // Call the API to create the sandbox meeting @ Chime
          const { sandboxMeetingResponse } =
            await apiClient.broadcast.createSandboxMeeting(
              teamId,
              eventId,
              broadcastId
            );

          const meetingId = sandboxMeetingResponse.Meeting.MeetingId;

          const { attendeeResponse } =
            await apiClient.broadcast.createMeetingAttendee(
              teamId,
              eventId,
              broadcastId,
              meetingId
            );

          socket.emit(CREATE_READINESS_CHECK, {
            sandboxMeetingResponse,
            attendeeResponse,
            broadcastId
          });

          return true;
        }
      };

      dispatch(action);
    }
  );
};
